import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking//cooking-report/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking//cooking-report/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking//cooking-report/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking//cooking-report/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking//cooking-report/detail',
    method: 'get',
    params: { id }
  })
}
export function putTop(params) {
  return request({
    url: '/cooking//cooking-report/zd',
    method: 'get',
    params
  })
}
